(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/middleware-transfer-rows/assets/utils/services.js') >= 0) return;  svs.modules.push('/components/payment/middleware-transfer-rows/assets/utils/services.js');
"use strict";


const {
  getDrawName
} = svs.utils.products;
const {
  ApiProxy,
  http,
  featureToggle
} = svs.components.lbUtils.apiProxy;
const cloudApiFeatureToggles = svs.components.lbUtils.cloudApi.cloudApiConstants;
const fetchOpenedDrawsPromise = async productId => {
  const drawAPIPath = getDrawName(productId);
  const customHandler = http.get("/draw/1/:product/draws", _ref => {
    let {
      data
    } = _ref;
    return data;
  }, {
    config: {
      shouldUseCloud: async () => {
        const isEnabled = await featureToggle(cloudApiFeatureToggles[drawAPIPath.toUpperCase()], {
          req: undefined
        });
        return isEnabled;
      },
      allowedProducts: ['bomben', 'matchen', 'europatipset', 'stryktipset'],
      cloudEndpointTemplate: '/v1/:product/draws'
    }
  });
  const apiProxy = new ApiProxy([customHandler]);
  let response;
  try {
    response = await apiProxy.fetch("/draw/1/".concat(drawAPIPath, "/draws"), {
      method: 'GET'
    });
  } catch (error) {
    svs.core.log.getLogger('draws-redux:fetchDrawsPromise').error("Error fetching opened draws for product ".concat(productId, ": ").concat(error));
    throw error;
  }
  return response.draws;
};
setGlobal('svs.components.payment.middleware.transferRows.services', {
  fetchOpenedDrawsPromise
});

 })(window);